import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridModule } from '@progress/kendo-angular-grid';
import { LWAReasonsRoutingModule } from './left-without-assistant-reasons-routing.module';
import { LWAReasonsComponent } from './left-without-assistant-reasons.component';
import { LWAReasonsGridComponent } from './lwa-reasons-grid/left-without-assistant-reasons-grid.component';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PopupModule } from '@progress/kendo-angular-popup';

@NgModule({
  declarations: [
    LWAReasonsComponent,
    LWAReasonsGridComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    GridModule,
    PopupModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    LWAReasonsRoutingModule
  ]
})
export class LWAReasonsModule { }